import PropTypes from 'prop-types';

export const CustomOptionsShape = PropTypes.shape({
  onError: PropTypes.func,
  interceptors: {
    request: PropTypes.func,
    response: PropTypes.func,
  },
});
